<script setup>
const gsapTimeline = useGsapTimeline()
const textElement = ref(null)

const props = defineProps({
  text: String,
  class: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['timeline', 'timelineOut'])

onMounted(() => {
  const timeline = gsapTimeline({ name: 'TextSlideUp' }).startInvisible(textElement).from(textElement, { y: '100%', duration: 0.44, ease: 'power1.out' }, '<')

  emit('timeline', timeline)

  const timelineOut = () => gsapTimeline({ name: 'TextSlideUp - Out' }).to(textElement, { y: '-100%', duration: 0.44, ease: 'power1.in' }, '<')
  emit('timelineOut', timelineOut)
})
</script>

<template>
  <div class="overflow-hidden translate-y-0">
    <div ref="textElement" :class="props.class" v-html="text" />
  </div>
</template>
